import store from '@vuex'
import response from '../response_builder/index'
import { parseError } from '@js/parsers/error.parser'
import { createTfaDialog } from '@js/modals/tfa_dalog.modal'
import { initHorizonServer } from '@js/helpers/server.helper'
import {errors} from '@js/errors/factory'
import {vuexTypes} from '@vuex/types'
import {dispatchAppEvent} from '@js/events/helpers'
import {commonEvents} from '@js/events/common_events'

export class OperationBuilder {
  constructor () {
    this.config = {}
    this.operations = []
    this.repeatDetails = {}
    this.isRawError = false
  }

  operation () {
    this.operations = []
    return this
  }

  add (operation) {
    if (!operation) return this
    this.operations.push(operation)
    return this
  }

  addMany (operations) {
    if (!operations) return this
    this.operations = operations
    return this
  }

  withRawError () {
    this.isRawError = true
    return this
  }

  submit (source, keypair, type) {
    const server = initHorizonServer(store.getters.networkPassphrase)
    const operations = this.operations
    return server.submitOperationGroup(operations, source, keypair, type)
      .then(rawResponse => response.getTransactionResponse(rawResponse))
      .catch(err => this._handleError(err))
  }

  repeat () {
    const server = initHorizonServer()
    const config = this.repeatDetails.config
    const tx = this.repeatDetails.tx
    return server.repeatTransaction(config, tx)
      .then(rawResponse => response.getTransactionResponse(rawResponse))
      .catch(err => this._handleError(err))
  }

  _handleError (error) {
    const parsedError = parseError(error)
    if (parsedError.meta.repeatDetails) this.repeatDetails = parsedError.meta.repeatDetails

    switch (parsedError.constructor) {
      case errors.OtpError:
        store.commit(vuexTypes.SET_FACTOR_DATA, parsedError.meta)
        return createTfaDialog(this.repeat.bind(this), parsedError.meta)

      case errors.TFARecoveryError:
        dispatchAppEvent(commonEvents.showTfaRecovery)
        return Promise.reject(error)

      default:
        return Promise.reject(parsedError)
    }
  }
}

export const operationBuilder = new OperationBuilder()



// WEBPACK FOOTER //
// ./src/js/builders/operation_builder/operation_builder.js